import React from 'react';
import {CollectionPreferences, StatusIndicator} from '@amzn/awsui-components-react-v3';
import {GetPreSignedUrlBlockFileName} from "../BulkHistoryTableContainer/GetPreSignedUrlBlockFileName";
import {GetPreSignedUrlBlockValidationReport} from "../BulkHistoryTableContainer/GetPreSignedUrlBlockValidationReport";

export const COLUMN_DEFINITIONS = [
    {
        id: 'requester',
        header: 'Requester',
        cell: (item: any) => item.requester,
        sortingField: 'requester',
        minWidth: 80
    },
    {
        id: "uploadedAt",
        header: "Request date",
        cell: (e: any)  => e.uploadedAt,
        sortingField: "uploadedAt",
        minWidth: 120
    },
    {
        id: "fileName",
        header: "File Name",
        cell: (e: any) => (
            <GetPreSignedUrlBlockFileName fileName={e.fileName} s3Key={e.s3Key}/>
        ),
        sortingField: "fileName",
        minWidth: 200
    },
    {
        id: "status",
        header: "Status",
        cell: (e: any) => (
            <>
                {e.status && e.status === "SUCCESS" && <StatusIndicator type="success"> File submitted </StatusIndicator>}
                {e.status && e.status === "FAILED" && <StatusIndicator type="error"> Failed to submit </StatusIndicator>}
                {e.status && e.status === "PENDING" && <StatusIndicator type="pending"> Pending </StatusIndicator>}
            </>
        ),
        sortingField: "status",
        minWidth: 80
    },
    {
        id: "validationReportS3Key",
        header: "Validation Report",
        cell: (e: any) => (
            <GetPreSignedUrlBlockValidationReport validationReportS3Key={e.validationReportS3Key} status={e.status}/>
        ),
        sortingField: "validationReportS3Key",
        minWidth: 160
    }
];

export const POLLING_INTERVAL = 5 * 1000;
export const POLLING_TIMEOUT =  10 * 60 * 1000;

export enum BULK_TEMPLATE_FILES {
    BULK_TEMPLATE_ALPHA = "s3://aws-scm-templates-alpha/SwiftBulkCreateTemplateFile.csv",
    BULK_TEMPLATE_BETA = "s3://aws-scm-templates-beta/SwiftBulkCreateTemplateFile.csv",
    BULK_TEMPLATE_PROD = "s3://aws-scm-templates-prod/SwiftBulkCreateTemplateFile.csv",
    PRODUCTION_COMPONENT_ALPHA = "s3://aws-scm-templates-alpha/ProductionComponentBulkCreateTemplateFile.csv",
    PRODUCTION_COMPONENT_BETA = "s3://aws-scm-templates-beta/ProductionComponentBulkCreateTemplateFile.csv",
    PRODUCTION_COMPONENT_PROD = "s3://aws-scm-templates-prod/ProductionComponentBulkCreateTemplateFile.csv"
}

export const BULK_CREATE_PROGRESS_BAR = {
    LABEL: "File uploaded, validation in progress",
    DESCRIPTION: "Your file has been successfully uploaded and is now being validated. Please wait for 1-2 minutes for the validation process to complete."
}

export const FILTERING_FIELDS = ["requester","uploadedAt","fileName", "status"];

const VISIBLE_CONTENT_OPTIONS = [
    {
        label: 'Main distribution properties',
        options: [
            { id: 'requester', label: 'Requester', editable: false },
            { id: 'uploadedAt', label: 'Request date' },
            { id: 'fileName', label: 'File Name' },
            { id: 'status', label: 'Status' },
            { id: 'validationReportS3Key', label: 'Validation Report' }
        ],
    },
];

export const PAGE_SIZE_OPTIONS = [
    { value: 10, label: '10 Entries' },
    { value: 20, label: '20 Entries' },
    { value: 30, label: '30 Entries' },
];

export const DEFAULT_PREFERENCES = {
    pageSize: 20,
    visibleContent: ["requester","uploadedAt","fileName", "status","validationReport", "validationReportS3Key"],
    wrapLines: false,
};

export const Preferences = ({ preferences, setPreferences, disabled,
                                pageSizeOptions = PAGE_SIZE_OPTIONS,
                                visibleContentOptions = VISIBLE_CONTENT_OPTIONS,
                            }) => {
    return (
        <CollectionPreferences
            title="Preferences"
            confirmLabel="Confirm"
            cancelLabel="Cancel"
            disabled={disabled}
            preferences={preferences}
            onConfirm={({detail}) => setPreferences(detail)}
            pageSizePreference={{
                title: 'Page size',
                options: pageSizeOptions,
            }}
            wrapLinesPreference={{
                label: 'Wrap lines',
                description: 'Check to see all the text and wrap the lines',
            }}
            visibleContentPreference={{
                title: 'Select visible columns',
                options: visibleContentOptions,
            }}
        />
    );
};